import React from 'react';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import Technologies from './sections/Technologies';
import Experience from './sections/Experience';
import Projects from './sections/Projects';
import Demos from './sections/Demos';
import Contact from './sections/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Technologies />
        <Experience />
        <Projects />
        <Demos />
        <Contact />
      </main>
    </div>
  );
}

export default App;
